// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelLarge } from 'baseui/typography';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Scrollbar } from '@lyon/components/utils/Scrollbar';
import { LyonUpdateFormTitle } from './LyonUpdateFormTitle';
import { LyonUpdateFormDescription } from './LyonUpdateFormDescription';
import { LyonUpdateFormOptionQuiz } from './LyonUpdateFormOptionQuiz';
import { LyonUpdateFormAccessCode } from './LyonUpdateFormAccessCode';
import { LyonUpdateFormSaveButton } from './LyonUpdateFormSaveButton';
import { LyonUpdateFormLock } from './LyonUpdateFormLock';
import { LyonUpdateFormIsPractice } from './LyonUpdateFormPractice';

// ANCHOR Styles
import { BLOCK, INNER } from './styles';

export const LyonUpdateFormSidebarOptionTab = constant(() => (
  <Block overrides={BLOCK}>
    <Scrollbar>
      <Block overrides={INNER}>
        <LabelLarge marginTop="8px" marginBottom="16px">
          Form settings
        </LabelLarge>
        <LyonUpdateFormTitle />
        <LyonUpdateFormDescription />
        <LyonUpdateFormAccessCode />
        <LyonUpdateFormLock />
        <LyonUpdateFormIsPractice />
        <LyonUpdateFormOptionQuiz />
      </Block>
    </Scrollbar>
    <LyonUpdateFormSaveButton />
  </Block>
));
